<template>
  <div v-show="shouldShow">
    <div class="add-story" @click="handleCreateUserStory">
      <span class="inner"></span>
    </div><!-- /.add-story -->

    <div class="user-story-single" v-bind:class="{focused: focused, expanded: view_options.show_description, hideEstimation: !estimating, readonly: readOnly}">
      <div class="story-actions">

        <div class="story-drag drag">
          <i class="far fa-bars"></i>
        </div><!-- /.story-drag -->

        <div class="story-count">
          <p>{{ userstory.id }}</p>
        </div><!-- /.story-count -->

        <button type="button" class="story-history" title="Version history" @click="toggleHistory">
          <i class="far fa-history"></i>
        </button><!-- /.story-history -->

        <div class="bottom">
          <button type="button" class="btn story-delete" @click="confirmDelete">
            <i class="far fa-trash"></i>
          </button><!-- /.story-delete -->
        </div><!-- /.bottom -->

      </div><!-- /.actions -->

      <div class="story-main">
        <div class="story-container focus">
          <div class="story">
            <textarea v-auto-height class="form-control" v-model="stateTitle" @focus="beganFocus" @keyup="markDirty" placeholder="Title" v-bind="{'readonly' : readOnly}"></textarea>
            <multiselect
              :options="tags"
              track-by="id"
              label="text"
              :value="stateTags"
              :multiple="true"
              :searchable="true"
              :close-on-select="false"
              :clear-on-select="false"
              :show-labels="false"
              placeholder="Add tags..."
              @input="handleSelectTagCallback"
              @search-change="searchTags"
              :taggable="true"
              :hideSelected="true"
              name="tags"
              class="tag-selector"
              :tag-placeholder="`Create new tag...`"
              @tag="handleAddNewTag"
              v-bind="{'disabled' : readOnly}"
              >
          </multiselect>

          </div><!-- /.story -->
          <div class="description">
            <wysiwyg-inline
              v-if="focused && !readOnly"
              v-auto-height
              v-show="view_options.show_description"
              :content="stateDescription"
              :save="saveDescription"
              :focus="focusWysiwyg"
              placeholder="Description"
            ></wysiwyg-inline>
            <p v-else v-html="stateDescription" @click="wysiwygFocus" />
          </div><!-- /.description -->
          <div class="effort-holder">
            <ul class="effort" v-if="view_options.show_times">
              <li>
                <span class="letter">C</span>
                <input type="text" class="number" placeholder="?" @focus="beganFocus" @keyup="markDirty" v-model="stateComplexity" v-bind="{'readonly' : readOnly}" />
              </li>
              <li>
                <span class="letter">E</span>
                <input type="text" class="number" placeholder="?" @focus="beganFocus" @keyup="markDirty" v-model="stateEstimate" v-bind="{'readonly' : readOnly}" />
              </li>
              <li>
                <span class="letter">R</span>
                <input type="text" class="number" placeholder="?" @focus="beganFocus" @keyup="markDirty" v-model="stateAdjustedEstimate" readonly />
              </li>
            </ul><!-- /.effort -->
            <ul class="group">
              <multiselect v-model="group" :options="groups" label="text" track-by="id" :taggable="true" @tag="newGroup" tag-placeholder="New group" @select="groupSelected" v-bind="{'disabled' : readOnly}"></multiselect>
            </ul>
          </div>

        </div><!-- /.story-container -->
        <div class="tech-notes" v-show="view_options.show_technical_notes">
          <h4>Technical Notes</h4>
          <div class="editable">
            <textarea v-auto-height class="form-control" v-model="stateTechNotes" @focus="beganFocus" @keyup="markDirty" placeholder="Tech Notes" v-bind="{'readonly' : readOnly}"></textarea>
          </div>
          <recorder :save="saveAudio" :delete="deleteAudio" :recording="userstory.recording"  v-if="view_options.show_recording"></recorder>
        </div><!-- /.tech-notes -->
        <div class="testing-notes" v-show="view_options.show_testing_notes">
          <h4>Testing Notes</h4>
          <div class="editable">
            <textarea v-auto-height class="form-control" v-model="stateTestNotes" @focus="beganFocus" @keyup="markDirty" placeholder="Testing Notes" v-bind="{'readonly' : readOnly}"></textarea>
          </div>
        </div><!-- /.testing-notes -->
      </div><!-- /.main -->
    </div>
  </div>
</template>

<script>

  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
  import { notify } from 'utils'
  import { SET_SAVE_STATUS } from 'vx/mutations'
  import { debounce, clone, findIndex } from 'lodash'
  import AppConstants from '@/support/app-constants'
  import { http } from 'utils'
  import { isEqual, find, each, isNaN, toNumber, cloneDeep, filter, map, intersectionBy } from 'lodash'
  import Multiselect from 'vue-multiselect'
  import { stateMapper } from 'mixins/user-stories'
  import Recorder from 'components/form/recording/recording.vue'
  import { WysiwygInline } from "components/form/input"

  var Story = require('./../../models/story.js');

  export default {
    mixins: [stateMapper],

    props: ['userstory', 'epic', 'parentOrder', 'epicIndex', 'storyIndex'],

    components: {
      Multiselect,
      Recorder,
      WysiwygInline
    },

    data: function () {
      return {
          focused: false,
          focusWysiwyg: false,
          dirty: false,
          lastSaved: new Date(),
          lastSent: JSON.parse(JSON.stringify(this.userstory)),
          readOnly: false,
          comments: [
               {
               	id: 1,
               	by: 1,
               	text: 'First Leve Comment',
               	kids: []
               }
          ],
          newUserStory: new Story(),
          saveDebounce: debounce(function () {
            this.handleUpdateUserStory()
          }, 2500)
      }
    },

    computed: {
      ...mapState('settings/userstories', ['view_options', 'filters']),
      ...mapState('settings/app', ['save_status']),
      ...mapState('groups', ['groups']),
      ...mapState('epics', ['epics']),
      ...mapGetters('groups', ['getGroupById']),
      ...mapState('tags', ['tags']),

      group: {
        get: function() {
          if (this.userstory && this.userstory.group_id > 0) {
            return this.getGroupById(this.userstory.group_id)
          }

        },
        set: function(group) {
          if (group) {
            this.stateGroupId = group.id
          } else {
            this.stateGroupId = null
          }

          this.markDirty()
        }
      },

      order () {
          return this.storyIndex + 1
      },

      estimating() {
      	return this.view_options.show_times
      },

      shouldShow() {
        var meetsGroups = true
        var meetsTags = true
        var meetsEstimation = true

        if (this.filters.selectedGroups.length > 0) {

          if (findIndex(this.filters.selectedGroups, existing => existing.id === this.userstory.group_id) >= 0) {
            meetsGroups = true
          } else {
            meetsGroups = false
          }
        }

        if (this.filters.selectedTags.length > 0) {

          if (intersectionBy(this.filters.selectedTags, this.userstory.tags, 'id').length > 0) {
            meetsTags = true
          } else {
            meetsTags = false
          }
        }

        if (this.filters.estimation.length > 0) {
          if (this.filters.estimation === 'Estimated') {
            meetsEstimation = this.userstory.estimate > 0
          } else if (this.filters.estimation === 'Missing Estimate') {
            meetsEstimation = this.userstory.estimate <= 0
          }
        }

        return (meetsGroups && meetsTags && meetsEstimation)
      }
    },

    mounted: function() {

    	this.$bus.$on('us-focus', (us) => {

  			if (us.id != this.userstory.id) {

  				if (!this.dirty) { this.focused = false; return }

  				this.handleUpdateUserStory().then(() => {
  					this.focused = false;
  				});
  			}
      });

      if (this.userstory.has_children) {
        this.readOnly = true
      }
    },

    watch: {
        'userstory.locked_by': function(newVal, old) {
        	this.readOnly = parseInt(newVal) > 0;
        }
    },

    methods: {
      ...mapMutations('settings/app', [SET_SAVE_STATUS]),
      ...mapActions('groups', ['addGroup']),
      ...mapActions('epics', ['addUserStory', 'updateUserStory', 'deleteUserStory']),
      ...mapActions('tags', ['getTagsList', 'addTag']),

      saveDescription (value) {
        return new Promise(() => {
          this.stateDescription = value
          this.markDirty()
        })
      },

      wysiwygFocus () {
        if (!this.readOnly) {
          this.focusWysiwyg = true
          this.beganFocus()
        }
      },

      handleCreateUserStory () {

          this.newUserStory.epic_id = this.epic.id
          this.newUserStory.order = this.storyIndex + 1
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

          this.addUserStory({
            id: this.epic.user_story_document_id,
            index: this.storyIndex,
            payload: this.newUserStory
          }).then((response) => {

            //reset the form data
            this.newUserStory = new Story()
            this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
          }).catch((response) => {
            notify.error('There was an issue trying to create your user story!')
            this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
          })
      },

      saveAudio (audioBlob) {
        let formData = new FormData();
        formData.append('audio', audioBlob);
        formData.append('_method', 'put'); //PUT + multipart form request + php = no

        http.post(`/user-story-document/${this.epic.user_story_document_id}/stories/${this.userstory.id}`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
          console.log(response)
          this.stateRecording = response.data.recording
        })
      },

      deleteAudio () {
        this.$swal(
        		{
        			title: 'Confirm Delete',
        			html: 'Are you sure you want to delete the recording for US #'+ this.userstory.id + '?',
        			type: 'question',
        			showCancelButton: true,
        			confirmButtonText: 'Delete',
        		}).then(() => {
        			this.stateRecording = null
              this.markDirty()
        	}, function() {
        });
      },

      handleSelectTagCallback (tags) {
        if (tags) {
          this.stateTags = tags
        } else {
          this.stateTags = []
        }

        this.markDirty()
      },

      searchTags: debounce(async function (search) {
        await this.getTagsList({ text: search })
      }, 1250),



      markDirty () {

        this.dirty = true
        this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)

        this.saveDebounce()
      },

      async toggleHistory () {
        if (this.dirty) {
          this.saveDebounce.cancel()
          await this.handleUpdateUserStory()
        }

        this.$bus.$emit('us-history', { storyId: this.userstory.id })
      },

    	confirmDelete() {

    		this.$swal(
        		{
        			title: 'Confirm Delete',
        			html: 'Are you sure you want to delete US #' + this.userstory.id + '<br> this will reset this epics ordering.',
        			type: 'question',
        			showCancelButton: true,
        			confirmButtonText: 'Delete',
        		}).then(() => {
        			this.handleDeleteUserStory();
        	}, function() {
        });
    	},

    	handleDeleteUserStory () {
        	var that = this;
          var userstory = clone(this.userstory)
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

          return this.deleteUserStory({
            docId: this.epic.user_story_document_id,
            userstory: this.userstory
          }).then((response) => {
            //Send broadcast to send re-order so the api will reorder and return a fresh userstory list with updated indexes
            this.$bus.$emit('delete-user-story', userstory.epic_id);
            this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
          }).catch((response) => {

            if (response.status.code == 422) {
                var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                notify.error(firstValidationIssue)
                this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
            } else {
                notify.error('An unexpected error occured!')
                this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
            }
          })
        },

        beganFocus () {

        	if (!this.focused) {
            	this.focused = true
            	this.$bus.$emit('us-focus', {id: this.userstory.id})
        	}

        },

        handleUpdateUserStory () {
            var that = this
            this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

            return this.updateUserStory({
              docId: this.epic.user_story_document_id,
              storyId: this.userstory.id,
              payload: this.userstory,
              refresh: false
            }).then((response) => {
              this.dirty = false
              this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
            }).catch((response) => {
              notify.error(response.response.data.errors[Object.keys(response.response.data.errors)[0]])
            })
        },

        handleAddNewTag(text) {
          this.addTag({ text: text }).then((response) => {
            let tags = clone(this.stateTags)
            tags.push(response.data)

            this.stateTags = tags
            this.markDirty()
          })
        },

        newGroup (group, callback) {
          return this.addGroup({
            docId: this.epic.user_story_document_id,
            storyId: this.userstory.id,
            payload: { text: group }
          }).then((response) => {

            this.stateGroup = response.data
            this.groupSelected(response.data)
          })
        },

        groupSelected(group) {
          this.userstory.group_id = group.id
          this.markDirty();
        }
    }
}

</script>
